import { render, staticRenderFns } from "./CustomerTabManageAccount.vue?vue&type=template&id=6209cbbb"
import script from "./CustomerTabManageAccount.vue?vue&type=script&lang=ts"
export * from "./CustomerTabManageAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports